import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Header, Icon, Table, Label } from "semantic-ui-react";
import { getAdminPaymentsForUser, exportPayments } from "services/payment";
import { adminGetAllUsers } from "services/user";
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import { getAllCenters } from "services/center";
import { getFullName } from "utils/displayName";
import CustomPagination from "components/CustomPagination";

const styles = {
	blocWhite: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
		overflowY: "auto",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
		color: "white",
	},
	icon: { cursor: "pointer", color: "white", fontSize: "1.2em", marginLeft: "10px" },
	select2: {
		container: (provided) => ({
			...provided,
			width: "260px",
			cursor: "pointer",
			margin: "5px 0",
			fontSize: "0.9rem",
			color: "teal",
			height: 38,
			paddingRight: 10,
		}),
		option: (provided) => ({
			...provided,
			cursor: "pointer",
			fontSize: "0.9em",
			textAlign: "left",
		}),
		control: (provided) => ({
			...provided,
			cursor: "pointer",
		}),
	},
};

const Factu = () => {
	const yesterday = ((d) => new Date(d.setDate(d.getDate() - 1)))(new Date());
	const dispatch = useDispatch();
	const [startDate, setStartDate] = useState(yesterday);
	const [endDate, setEndDate] = useState(yesterday);
	const [payments, setPayments] = useState([]);
	const [selectedUser, setSelectedUser] = useState(null);
	const [selectedCenter, setSelectedCenter] = useState(null);
	const [selectedMode, setSelectedMode] = useState(null);
	const [users, setUsers] = useState([]);
	const [centers, setCenters] = useState([]);
	const [total, setTotal] = useState(0);
	const [totalAmount, setTotalAmount] = useState(0);
	const [pagination, setPagination] = useState({ page: 1, numberOfPages: 1 });
	const [activePage, setActivePage] = useState(1);

	useEffect(() => {
		dispatch(adminGetAllUsers()).then((res) => {
			if (res && res.payload && res.payload.data && res.payload.data) setUsers(res.payload.data);
		});
		dispatch(getAllCenters()).then((res) => {
			if (res && res.payload && res.payload.data && res.payload.data) setCenters(res.payload.data);
		});
	}, []);
	useEffect(() => {
		dispatch(
			getAdminPaymentsForUser(
				startDate,
				endDate,
				activePage,
				50,
				"",
				selectedCenter ? selectedCenter.value : null,
				"",
				selectedUser ? selectedUser.value : null,
				selectedMode ? selectedMode.value : null
			)
		).then((res) => {
			if (res && res.payload && res.payload.data && res.payload.data.payments) setPayments(res.payload.data.payments);
			if (res && res.payload && res.payload.data) {
				setPagination({ page: activePage, numberOfPages: Math.ceil(res.payload.data.count / 50) });
				setTotal(res.payload.data.count);
				setTotalAmount(res.payload.data.totalAmount);
			}
		});
	}, [startDate, endDate, selectedUser, selectedCenter, activePage, selectedMode]);

	const exportPaymentsToExcell = () => {
		dispatch(
			exportPayments(
				startDate,
				endDate,
				activePage,
				50,
				"",
				selectedCenter ? [selectedCenter.value] : [],
				"",
				selectedUser ? selectedUser.value : null,
				selectedMode ? selectedMode.value : null
			)
		).then((res) => {
			const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.payload.data.base64}`;
			const downloadLink = document.createElement("a");
			const fileName = `payments${moment().format("DD-MM-YYYY")}.xlsx`;
			downloadLink.href = linkSource;
			downloadLink.download = fileName;
			downloadLink.click();
		});
	};
	const getStatusFolder = (folder) => {
		if (!folder) return "";
		switch (folder.status) {
			case "PENDING":
			case "NEW":
			case "HELP_NURSE":
				return "En cours";
			case "DONE":
				return "Terminé";
			case "CANCELED":
				return "Annulé";
			default:
				return "";
		}
	};

	return (
		<Grid textAlign="left" style={{ height: "100vh", overflowY: "scroll" }} verticalAlign="top">
			<Grid.Column style={{ maxWidth: 1250, padding: "50px 20px", margin: "auto", height: "93vh" }}>
				<Header as="h2" color="teal" textAlign="center" style={{ backgroundColor: "rgb(0, 147, 128)", borderRadius: "4px" }}>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "baseline",
							color: "white",
							backgroundColor: "rgb(67, 179, 158)",
							padding: "10px",
							borderRadius: "4px",
							flexDirection: "column",
							fontSize: "1.2rem",
						}}
					>
						<div>
							Résumé d'encaissement <Icon name="file excel" style={styles.icon} onClick={() => exportPaymentsToExcell()} />
						</div>
						<div style={{ display: "flex", justifyContent: "flex-end", alignItems: "baseline" }}>
							<Select
								isClearable
								name="user"
								customlabel="Utilisateurs"
								value={selectedUser}
								options={users.map((i) => ({
									value: String(i.id),
									label: `${i.first_name} ${i.last_name} (${i.login})`,
								}))}
								onChange={(user) => setSelectedUser(user)}
								styles={styles.select2}
								placeholder="Sélectionner un utilisateur"
							/>
							<Select
								isClearable
								name="center"
								customlabel="Centres"
								value={selectedCenter}
								options={centers.map((i) => ({
									value: String(i.id),
									label: `${i.abbreviation} - ${i.name}`,
								}))}
								onChange={(c) => setSelectedCenter(c)}
								styles={styles.select2}
								placeholder="Sélectionner un centre"
							/>
							<Select
								isClearable
								name="mode"
								customlabel="Mode de paiement"
								value={selectedMode}
								options={[
									{ value: "servipay", label: "Servipay" },
									{ value: "especes", label: "Espèces" },
									{ value: "sumup", label: "Sumup" },
									{ value: "stripe", label: "Stripe" },
									{ value: "voucher", label: "Voucher" },
									{ value: "toBill", label: "A facturer" },
								]}
								onChange={(c) => setSelectedMode(c)}
								styles={styles.select2}
								placeholder="Sélectionner un mode de paiement"
							/>
							<Icon name="calendar alternate" style={styles.icon} />
							Du{" "}
							<div style={{ width: "125px", fontSize: "0.9em", padding: "0 10px" }}>
								<DatePicker
									selected={new Date(startDate)}
									className="datePicker"
									onChange={(date) => {
										setStartDate(date);
									}}
									shouldCloseOnSelect={true}
									dateFormat={process.env.REACT_APP_DATE_DATEPICKER}
								/>
							</div>
							<div> au </div>
							<div style={{ width: "125px", fontSize: "0.9em", padding: "0 10px" }}>
								<DatePicker
									selected={new Date(endDate)}
									className="datePicker"
									onChange={(date) => {
										setEndDate(date);
									}}
									shouldCloseOnSelect={true}
									dateFormat={process.env.REACT_APP_DATE_DATEPICKER}
								/>
							</div>
						</div>
					</div>
				</Header>

				<div style={styles.blocWhite}>
					<div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "baseline" }}>
						{total > 0 && (
							<div>
								<span>Nombre de résultats : {total}</span>
							</div>
						)}
						{totalAmount > 0 && (
							<div>
								<span>
									Montant total : {totalAmount.toFixed(2)}
									{` €`}
								</span>
							</div>
						)}
						{pagination.numberOfPages > 1 && (
							<div>
								<CustomPagination
									activePage={pagination.page}
									totalPages={pagination.numberOfPages}
									onPageChange={(e, { activePage }) => {
										setActivePage(activePage);
									}}
								/>
							</div>
						)}
					</div>
					{payments.length > 0 && (
						<Table sortable celled fixed>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell>Centre</Table.HeaderCell>
									<Table.HeaderCell>Encaissé par</Table.HeaderCell>
									<Table.HeaderCell>Patient</Table.HeaderCell>
									<Table.HeaderCell>Montant</Table.HeaderCell>
									<Table.HeaderCell>Mode de paiement</Table.HeaderCell>
									<Table.HeaderCell>Date</Table.HeaderCell>
									<Table.HeaderCell>Cible</Table.HeaderCell>
								</Table.Row>
							</Table.Header>
							<Table.Body>
								{payments &&
									payments
										.filter((p) => p.price > 0)
										.map((payment) => (
											<Table.Row key={`sec-folder${payment.key}`}>
												<Table.Cell>{payment.folder?.labAppointment?.center?.name || payment.casing?.center?.name}</Table.Cell>
												<Table.Cell>
													{payment.cashier?.first_name} {payment.cashier?.last_name}
												</Table.Cell>

												<Table.Cell>{payment.folder?.patient ? getFullName(payment.folder?.patient) : payment.casing?.patient_name}</Table.Cell>
												<Table.Cell>{payment.price} €</Table.Cell>
												<Table.Cell>{payment.source === "toBill" ? "A facturer" : payment.source}</Table.Cell>
												<Table.Cell>
													<Label>
														{moment(payment.created_at).format("DD/MM/YYYY")} à {moment(payment.created_at).format("HH:mm")}
													</Label>
												</Table.Cell>
												<Table.Cell>
													{payment.casing && `Paiement direct`}
													<br />
													{payment.invoice_reference ? `Facture ${payment.invoice_reference}` : ""} <br />
													{payment.folder && `Dossier ${payment.folder?.code} - ${getStatusFolder(payment.folder)}`}
												</Table.Cell>
											</Table.Row>
										))}
							</Table.Body>
						</Table>
					)}
					{payments.length === 0 && "Aucun paiement pour cette période"}
				</div>
			</Grid.Column>
		</Grid>
	);
};

export default Factu;
